import React from 'react';
import { FileText, MousePointer2, CheckSquare, Download, Info } from 'lucide-react';

const steps = [
  {
    icon: FileText,
    title: 'Upload Invoices',
    description: 'Upload supplier invoices in PDF format. You can upload multiple invoices at once for quick processing.',
    color: 'bg-indigo-500'
  },
  {
    icon: MousePointer2,
    title: 'Extract Payment Details',
    description: 'The app will automatically read your invoices and extract important payment information: Supplier Name, IBAN, Amount, Invoice Reference/Number, and Payment Deadline.',
    color: 'bg-blue-500'
  },
  {
    icon: CheckSquare,
    title: 'Review and Edit Data',
    description: 'Review the extracted payment details in a simple table format. You can edit any details for accuracy.',
    color: 'bg-emerald-500'
  },
  {
    icon: Download,
    title: 'Pay with QR Codes',
    description: 'Each invoice will have a QR code generated for quick payment. Simply scan the QR code with your banking app to complete the payment.',
    color: 'bg-purple-500'
  }
];

export default function InstructionsSection() {
  return (
    <div className="py-12">
      <div className="max-w-4xl mx-auto space-y-8">
        {/* Steps */}
        <div className="grid grid-cols-1 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex items-start gap-6 p-6 rounded-xl bg-[#111] border border-gray-800 hover:border-gray-700 transition-colors"
            >
              <div className={`p-3 rounded-lg ${step.color} bg-opacity-10`}>
                <step.icon className={`w-6 h-6 ${step.color.replace('bg-', 'text-')}`} />
              </div>
              <div>
                <h3 className="text-lg font-medium text-[#c8c2bd] mb-2">
                  Step {index + 1}: {step.title}
                </h3>
                <p className="text-[#86868b] text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Supported Banking Systems */}
        <div className="bg-[#111] border border-gray-800 rounded-lg p-6">
          <div className="flex items-start gap-3">
            <div className="p-2 bg-indigo-500/10 rounded-lg">
              <Info className="w-5 h-5 text-indigo-500" />
            </div>
            <div>
              <h3 className="text-sm font-medium text-[#c8c2bd] mb-2">
                Supported Banking Systems
              </h3>
              <p className="text-[#86868b] text-sm mb-4">
                The generated QR codes are compatible with banking apps in:
              </p>
              <ul className="grid grid-cols-2 gap-2 text-sm text-[#86868b]">
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-indigo-500"></span>
                  Belgium
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-indigo-500"></span>
                  Germany
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-indigo-500"></span>
                  Austria
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-indigo-500"></span>
                  Finland
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}